export default class BundlesApi {
    static loadItem (params) {
        return (axios) => axios.get('/ribyt/rsvp/bundles/', {
            params,
        });
    }

    static updateItem (values, formValues, inviteHash) {
        return (axios) => axios.put(`/ribyt/rsvp/bundles/${ inviteHash }`, { byts: values, selection: formValues });
    }
}
